import React from 'react';

import './PanelRadioOptions.css';
import withErrorHandler from '../../../components/ErrorHandler';

const PanelRadioOptions = (props) => {
    const {
      label,
      value,
      onChange,
    } = props;

    return (
      <div className='a-radio-button' onClick={onChange}>
        <input type="radio" checked={value} onChange={onChange} />
        <label>{label}</label>
      </div>
    );
  };

export default withErrorHandler(React.memo(PanelRadioOptions));